var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  background-color: ', ';\n  background-image:  ', ';\n  background-position: center center;\n  background-size: cover;\n'], ['\n  width: 100%;\n  background-color: ', ';\n  background-image:  ', ';\n  background-position: center center;\n  background-size: cover;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  max-width: 1140px;\n  background-color: ', ';\n  background-image:  ', ';\n  background-size: cover;\n  background-position: center center;\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n  padding-top: 48px;\n  padding-bottom: 48px;\n  @media (max-width: 768px) {\n    padding-top: 24px;\n    padding-bottom: 24px;\n  }\n'], ['\n  max-width: 1140px;\n  background-color: ', ';\n  background-image:  ', ';\n  background-size: cover;\n  background-position: center center;\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n  padding-top: 48px;\n  padding-bottom: 48px;\n  @media (max-width: 768px) {\n    padding-top: 24px;\n    padding-bottom: 24px;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
var Container = styled.div(_templateObject, function (props) {
  return props.backgroundColor ? props.backgroundColor : 'transparent';
}, function (props) {
  return props.backgroundImage ? 'url(' + props.backgroundImage + ')' : 'none';
});
var Inner = styled.div(_templateObject2, function (props) {
  return props.innerBackgroundColor ? props.innerBackgroundColor : 'transparent';
}, function (props) {
  return props.innerBackgroundImage ? 'url(' + props.innerBackgroundImage + ')' : 'none';
});

var Wrapper = function Wrapper(props) {
  return React.createElement(Container, props, React.createElement(Inner, props, props.children));
};

export default Wrapper;